import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22Typography.jsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../assets/fonts/Domaine%20Display.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../assets/fonts/Domaine%20Display%20Medium%20Regular.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../assets/fonts/Domaine%20Display%20Semibold%20Regular.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22fallback%22:[%22Georgia%22,%22Times%20New%20Roman%22,%22serif%22]}],%22variableName%22:%22domaineDisplay%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'domaineDisplay', 'domaineDisplay Fallback', Georgia, Times New Roman, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
